import { Directive, ElementRef, EventEmitter, HostListener, inject, Output } from "@angular/core";

@Directive({
  selector: "[clickOutside]",
})
export class ClickOutsideDirective {
  @Output() clickOutside: EventEmitter<any> = new EventEmitter();

  #el = inject(ElementRef);

  @HostListener("document:click", ["$event"])
  onClickOutside(event: MouseEvent) {
    const clickedElement = event.target as Node;
    const clickedInside = (this.#el.nativeElement as HTMLElement).contains(clickedElement);

    if (!clickedInside) {
      this.clickOutside.emit();
    }
  }
}
